import React, { Component } from "react";
import Titulo from "../../generico/TituloPagina";
import DataTable from 'react-data-table-component';
import {formatoSeparadorMilesValue} from '../../generico/utils/FormatoInput'
import DatosSocio from "../../generico/DatosSocio"
import { trackPromise } from "react-promise-tracker";
import authService from "../../../services/login/auth.service";
import PatronService from "../../../services/consultas/padronService";
import Popup from "react-popup";
import { MapConsumer } from "react-leaflet";


export default class Padron extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaDeliberativa: [],
      listaHabilitado: [],
      listaNoHabilitado: [], 
      fechaAsambleaOmit: true,
      mesaAsambleaOmit: true,
      ordenAsambleaOmit: true,
      depAsambleaOmit: true,
      ciudadAsambleaOmit:true,
      map1: new Map()
    };
  }
  componentDidMount() {
    this.obtenerPadron()
  
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

    obtenerPadron = () => {
    var textos = [];
    var habilitados = [];
    var noHabilitados = [];
      trackPromise(
        PatronService.padrones("WEB")
          .then((response) => {
            let titulos;
            let deliberativa;
            let electiva
            var data = JSON.stringify(response.data);
            var jsonData = JSON.parse(data);
            console.log(jsonData)
             var map1 = new Map();
            if (jsonData.codigo === "0") {
              if(jsonData.textosInformativos.length !== 0){
               
                for (var i = 0; i < jsonData.textosInformativos.length; i++) {
                  map1.set(jsonData.textosInformativos[i].dominio, jsonData.textosInformativos[i].descripcion)
                  if(jsonData.textosInformativos[i].dominio === "PADRON.DELIBERATIVA"){
                    deliberativa = jsonData.textosInformativos[i].descripcion; 
                  }
                  if(jsonData.textosInformativos[i].dominio === "PADRON.ELECTIVA"){
                    electiva = jsonData.textosInformativos[i].descripcion; 
                  }

                  if(jsonData.textosInformativos[i].dominio === "PADRON.TITULO" ){
                   titulos = jsonData.textosInformativos[i].descripcion;
                   console.log("info", titulos)
                  }
                  else{
                    
                    textos.push({
                      concepto: jsonData.textosInformativos[i].descripcion,
                      
                    });
                  }
                }
              }
              
                if(jsonData.resultadoHabilitado !== null){
                for (var i = 0; i < jsonData.resultadoHabilitado.length; i++) {
                  var fechaAsambleaOmit = jsonData.resultadoHabilitado[i].fechaAsamblea == null ? true : false;
                  var mesaAsambleaOmit = jsonData.resultadoHabilitado[i].mesa == null ? true : false;
                  var ordenAsambleaOmit = jsonData.resultadoHabilitado[i].orden == null ? true : false;
                  var depAsambleaOmit = jsonData.resultadoHabilitado[i].departamento == null ? true : false;
                  var ciudadAsambleaOmit = jsonData.resultadoHabilitado[i].ciudad == null ? true : false;

                  habilitados.push({
                    mesa: jsonData.resultadoHabilitado[i].mesa,
                    orden: jsonData.resultadoHabilitado[i].orden,
                    fechaAsamblea: jsonData.resultadoHabilitado[i].fechaAsamblea,
                    departamento: jsonData.resultadoHabilitado[i].departamento,
                    ciudad: jsonData.resultadoHabilitado[i].ciudad,
                    
                  });
              
              }
                }
              if(jsonData.resultadoNoHabilitado !== null){
                for (var i = 0; i < jsonData.resultadoNoHabilitado.length; i++) {
               
                  noHabilitados.push({
                    ahorroProgramado: formatoSeparadorMilesValue(jsonData.resultadoNoHabilitado[i].ahorroProgramado) + " GS.",
                    aporte: formatoSeparadorMilesValue(jsonData.resultadoNoHabilitado[i].aporte) + " GS.",
                    fechaAsamblea: jsonData.resultadoNoHabilitado[i].fechaAsamblea,
                    saldoRojo: formatoSeparadorMilesValue(jsonData.resultadoNoHabilitado[i].saldoRojo) + " GS.",
                    sepelio: formatoSeparadorMilesValue(jsonData.resultadoNoHabilitado[i].sepelio) + " GS.",
                    solidaridad: formatoSeparadorMilesValue(jsonData.resultadoNoHabilitado[i].solidaridad) + " GS.",
                    tarjetas: formatoSeparadorMilesValue(jsonData.resultadoNoHabilitado[i].tarjetas) + " GS.",
                  });
           
              }
     }
              this.setState({titulo:titulos,deliberativa:deliberativa, electiva: electiva, map1:map1, listaDeliberativa: textos, listaHabilitado: habilitados, listaNoHabilitado: noHabilitados, fechaAsambleaOmit: fechaAsambleaOmit,mesaAsambleaOmit: mesaAsambleaOmit, ordenAsambleaOmit:ordenAsambleaOmit, depAsambleaOmit:depAsambleaOmit, ciudadAsambleaOmit:ciudadAsambleaOmit  });
            }
            else {
              Popup.queue(this.notifiPopup("Error", jsonData.mensaje));
              return;
            }
         
          }
  
          ).catch(function (error) {
      
            authService.logout()
          })
      );
  
    }
  

  getColumnDeliberativa() {
    return [
    {
      name: "concepto",
      selector: row => row.concepto,
    },]
  }
  

  getColumnNoHabilitado() {
    return [
    {
      name: "Fecha de Asamblea",
      selector: row => row.fechaAsamblea,
    },
    {
      name: "Aporte",
      selector: row => row.aporte,
      right: true,
      width:"150px"
    },
    {
      name: "solidaridad",
      selector: row => row.solidaridad,
      right: true,
      width:"150px"
    },
    {
      name: "Ahorro Programado",
      selector: row => row.ahorroProgramado,
      right: true,
      width:"150px"
    },
    {
      name: "Tarjeta",
      selector: row => row.tarjetas,
      right: true,
      width:"150px"
    },
    {
      name: "Saldo Rojo",
      selector: row => row.saldoRojo,
      right: true,
      width:"150px"
    },
    {
      name: "Sepelio",
      selector: row => row.sepelio,
      right: true,
      width:"150px"
    }]
  }

  

  getColumnHabilitado() {
    return [
    {
      name: "Mesa",
      selector: row => row.mesa,
      omit: this.state.mesaAsambleaOmit
    },
    {
      name: "Orden",
      selector: row => row.orden,
      omit: this.state.ordenAsambleaOmit
    },
    {
      name: "Fecha Asamblea",
      selector: row => row.fechaAsamblea,
      omit: this.state.fechaAsambleaOmit
    },
    {
      name: "Departamento",
      selector: row => row.departamento,
      width:"200px",      
      omit: this.state.depAsambleaOmit
    },
    {
      name: "Ciudad",
      selector: row => row.ciudad,
      width:"200px",
      omit: this.state.ciudadAsambleaOmit
    }]
  }

  
  render() {
    return (
      // Session deliberativa
      <div className="content-wrapper">
        <Titulo texto="Consulta Padrón" />
        <section className="content">
          <div className="container">    
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <DatosSocio/>              
                  </div>
                 
                  <div className="card-body">
                    <div className="seccion-excedente">
                    
                      <div className="col-md-12">
                        <div className="table-responsive">
                          <h2>Asamblea Deliberativa</h2>
                          <p>{this.state.map1.get('PADRON.FECHA_ASAMBLEA_INICIAL')} </p>
                          <p>{this.state.map1.get('PADRON.DIRECCION')} </p>
                          <p>{this.state.map1.get('PADRON.LOCAL')} </p>
                          
                        </div>
                      </div>
                      
                     <div></div>
                    
                    {this.state.listaHabilitado.length !== 0   ?
                      <div className="col-md-12">
                        <div className="table-responsive">
                          <h4>Asamblea Deliberativa - Habilitado con voz y voto</h4>
                          <span>{this.state.map1.get('PADRON.FECHA_ASAMBLEA_INICIAL')} </span>                          
                        </div>                        
                      </div>          
                     :
                     <div></div>
                   }
                       
                  
                   <br/>
                   {this.state.listaNoHabilitado.length !== 0 && this.state.deliberativa === 'true'  ?
                    <div>
                        <div className="col-md-12">
                          <div className="table-responsive">
                          <h4>Asamblea Deliberativa - Habilitado solo con voz</h4>
                            <DataTable                            
                              
                              columns={this.getColumnNoHabilitado()}
                              data={this.state.listaNoHabilitado}
                              dense={true}
                              noDataComponent="no hay registros para mostrar"/>
                          </div>
                          
                        </div>     
                       
                         
                      {/*<div className="col-md-12"> 
                        <br/>                 
                        <div class="callout callout-success" style={{border: "1px solid rgb(0, 106, 45)", boxShadow: "none"}}>
                          <div class="row">
                            <div class="col-md-12">
                              <span style={{fontSize: 20}}>Motivo:</span> Compromisos no pagados en fecha
                            </div>
                          </div>
                        </div>
                      </div> */}
                    </div>  
                    : <div></div>  
                    } 
                 
                        
                  </div>
                  </div>



                 {/* session electiva */}
                  <div className="card-body">
                    <div className="seccion-excedente">
                    {this.state.electiva === 'true'  ?
                      <div className="col-md-12">
                       <h2>Asamblea Electiva</h2>
                          <p>Fecha de la Asamblea: {this.state.map1.get('PADRON.FECHA_ELECTIVA')} </p>
                          <p>{this.state.map1.get('PADRON.DIRECCION_ELECTIVA')} </p>
                          <p>{this.state.map1.get('PADRON.LOCAL_ELECTIVA')} </p>
                      </div>
                     : <div></div>  
                    } 

                    {this.state.listaHabilitado.length !== 0 && this.state.electiva === 'true'  ?
                      <div className="col-md-12">
                        <div className="table-responsive">
                        <h4>Asamblea Electiva - Habilitado con voz y voto</h4>
                          <DataTable                            
                            columns={this.getColumnHabilitado()}
                            data={this.state.listaHabilitado}
                            dense={true}
                            noDataComponent="no hay registros para mostrar"/>                          
                        </div>                        
                      </div>          
                     :
                     <div></div>
                   }
                       
                  
                   <br/>
                   {this.state.listaNoHabilitado.length !== 0 && this.state.electiva === 'true'  ?
                    <div>
                        <div className="col-md-12">
                          <div className="table-responsive">
                          <h4>Asamblea Electiva - Habilitado solo con voz</h4>
                            <DataTable                            
                              columns={this.getColumnNoHabilitado()}
                              data={this.state.listaNoHabilitado}
                              dense={true}
                              noDataComponent="no hay registros para mostrar"/>
                          </div>
                          
                        </div>     
                       
                         
                      {/*<div className="col-md-12"> 
                        <br/>                 
                        <div class="callout callout-success" style={{border: "1px solid rgb(0, 106, 45)", boxShadow: "none"}}>
                          <div class="row">
                            <div class="col-md-12">
                              <span style={{fontSize: 20}}>Motivo:</span> Compromisos no pagados en fecha
                            </div>
                          </div>
                        </div>
                      </div> */}
                    </div>  
                    : <div></div>  
                    } 
                 
                        
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

    
                    

    );
  }
}
